import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface IContentMeta {
  contentUrl: string;
  fullTitle: string;
  contentDate: Date;
  metaImageUrl: string;
  coverImageUrl: string;
  description: string;
  languageCode: string;
  commentsCount: number;
}

@Component({
  selector: 'app-content-meta',
  templateUrl: './content-meta.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentMetaComponent {
  @Input() meta: IContentMeta;
}
